<template>
	<div class="content-card">
		<div class="card-header">
			<h2>个人资料</h2>
		</div>

		<div class="profile-form">
			<!-- Avatar Upload -->
			<div class="avatar-upload">
				<input type="file" ref="fileInput" @change="handleFileUpload" style="display: none" accept="image/*">
				<div class="upload-circle" @click="triggerFileInput">
					<img :src="form.avatarImg || 'https://api.dicebear.com/7.x/avataaars/svg?seed=Felix'"
						alt="Avatar" />
				</div>
				<p class="upload-text" @click="triggerFileInput">点击修改头像</p>
			</div>

			<!-- Form Fields -->
			<div class="form-group">
				<label>昵称</label>
				<input type="text" v-model="form.nickname" class="form-input" placeholder="请输入昵称" />
			</div>

			<div class="form-group">
				<label>手机号</label>
				<input type="text" v-model="form.phone" class="form-input" disabled style='color:#fff' />
			</div>

			<div class="form-group">
				<label>性别</label>
				<div class="radio-group">
					<label class="radio-label">
						<input type="radio" :value="1" v-model="form.gender" />
						<span class="radio-custom"></span>
						男
					</label>
					<label class="radio-label">
						<input type="radio" :value="0" v-model="form.gender" />
						<span class="radio-custom"></span>
						女
					</label>
				</div>
			</div>

			<div class="form-group">
				<label>生日</label>
				<input type="date" v-model="form.birthday" class="form-input" />
			</div>

			<div class="form-group" v-if="form.isMember === 1">
				<label>会员到期</label>
				<input type="text" :value="form.memberExpireTime" class="form-input" disabled style='color:#fff' />
			</div>

			<!-- Save Button -->
			<div class="form-actions">
				<button class="save-btn" @click="saveProfile" :disabled="loading">
					{{ loading ? '保存中...' : '保存' }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getUserProfile,
		updateUserProfile
	} from '@/api/user'
	import {
		uploadFile
	} from '@/api/common'
	import eventBus from '@/utils/eventBus'
	import {
		ElMessage
	} from 'element-plus'
	import 'element-plus/es/components/message/style/css'

	export default {
		name: 'UserProfile',
		data() {
			return {
				loading: false,
				form: {
					nickname: '',
					avatarImg: '',
					phone: '',
					gender: 1, // Default to male
					birthday: '',
					isMember: 0,
					memberExpireTime: '',
					balance: 0
				}
			}
		},
		created() {
			this.fetchUserProfile()
		},
		methods: {
			triggerFileInput() {
				this.$refs.fileInput.click()
			},
			async handleFileUpload(event) {
				const file = event.target.files[0]
				if (!file) return

				const formData = new FormData()
				formData.append('file', file)

				try {
					const res = await uploadFile(formData)
					if (res.url) {
						this.form.avatarImg = res.url
					} else if (res.fileName) {
						this.form.avatarImg = res.fileName
					} else {
						console.warn('Unknown upload response format:', res)
						this.form.avatarImg = typeof res === 'string' ? res : (res.url || res.fileName)
					}
					event.target.value = ''
					ElMessage.success('头像上传成功')
				} catch (error) {
					console.error('Upload failed:', error)
					ElMessage.error('上传失败，请稍后重试')
				}
			},
			async fetchUserProfile() {
				try {
					const res = await getUserProfile()
					this.form = {
						...this.form,
						...res
					}
					if (this.form.gender !== undefined) {
						this.form.gender = Number(this.form.gender)
					}
				} catch (error) {
					console.error('Failed to fetch profile:', error)
				}
			},
			async saveProfile() {
				if (this.loading) return
				this.loading = true
				try {
					await updateUserProfile({
						nickname: this.form.nickname,
						avatarImg: this.form.avatarImg,
						gender: this.form.gender,
						birthday: this.form.birthday
					})
					ElMessage.success('保存成功')

					// Update local user info
					const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
					userInfo.nickName = this.form.nickname;
					userInfo.sex = this.form.gender;
					userInfo.avatarImg = this.form.avatarImg;
					localStorage.setItem('userInfo', JSON.stringify(userInfo));

					// Emit event to update header
					if (eventBus && eventBus.emit) {
						eventBus.emit('login-success');
					}

					this.fetchUserProfile()
				} catch (error) {
					console.error('Failed to save profile:', error)
					ElMessage.error(error.message || '保存失败，请稍后重试')
				} finally {
					this.loading = false
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.content-card {
		background-color: #1e1e1e;
		border-radius: 4px;
		min-height: 600px;
		padding: 30px 40px;
		border-bottom: 1px solid #333;

		.card-header {
			margin-bottom: 40px;

			h2 {
				font-size: 18px;
				font-weight: normal;
				color: #ddd;
				padding-bottom: 15px;
				display: inline-block;
				border-bottom: 2px solid #ff9900;
				margin: 0;
			}
		}

		/* Form Styles */
		.profile-form {
			max-width: 300px;
			margin: 0 auto;

			.avatar-upload {
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 10px;
				margin-bottom: 40px;

				.upload-circle {
					width: 80px;
					height: 80px;
					border-radius: 50%;
					overflow: hidden;
					cursor: pointer;
					border: 2px solid #333;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}

				.upload-text {
					font-size: 12px;
					color: #666;
					margin: 0;
					cursor: pointer;
				}
			}

			.form-group {
				display: flex;
				align-items: center;
				margin-bottom: 25px;

				label {
					width: 80px;
					color: #999;
					font-size: 14px;
				}

				.form-input {
					flex: 1;
					background-color: transparent;
					border: none;
					border-bottom: 1px solid #333;
					padding: 10px 0;
					color: #fff;
					font-size: 14px;
					outline: none;

					&:focus {
						border-bottom-color: #ff9900;
					}

					&:disabled {
						color: #666;
					}
				}

				.radio-group {
					display: flex;
					gap: 30px;

					.radio-label {
						display: flex;
						align-items: center;
						gap: 8px;
						cursor: pointer;
						font-size: 14px;

						input {
							display: none;
						}

						.radio-custom {
							width: 16px;
							height: 16px;
							background-image: url('@/assets/icon/notSelected.png');
							background-size: cover;
							display: block;
						}

						input:checked+.radio-custom {
							background-image: url('@/assets/icon/selected.png');
						}
					}
				}
			}

			.form-actions {
				display: flex;
				justify-content: center;
				margin-top: 50px;

				.save-btn {
					background-color: #FE8E04;
					color: #fff;
					border: none;
					padding: 10px 50px;
					border-radius: 4px;
					font-size: 14px;
					cursor: pointer;
					transition: opacity 0.3s;

					&:hover {
						opacity: 0.9;
					}
				}
			}
		}
	}
</style>